<template>
  <div>
    <Header :title="'スカウト件数調査'" />
    <div
      class="boss-admin-container clearfix"
      style="margin-left:-170px"
    >
      <router-view />
    </div>
  </div>
</template>

<script>
import Header from '@/components/templates/Header'
import { mapActions } from 'vuex'

export default {
  components: {
    Header
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'Login') { next() }
    next(false)
  },
  created () {
    const masters = [
      'genders',
      'educationalBackgrounds',
      'prefectures',
      'occupations',
      'businesses',
      'languageSkills',
      'changeJobsMotivations',
      'companyStyles',
      'skills',
      'licenses'
    ]
    masters.forEach(element => {
      this.storeMaster(element)
    })
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ])
  }
}
</script>
